module.exports = __webpack_public_path__ + "img/page_1_5.8867d84e.png";